interface Config {
    apiUrl: string,
    helpUrl: string,
    oidcSettings: {
      authority: string
      client_id: string
      scope: string
      response_type: string
      redirect_uri: string
      post_logout_redirect_uri: string
      monitorSession: boolean,
      prompt: string
    } 
  }
  
  export let config = buildConfig(process.env)
  
  function buildConfig(env: any): Config {
    if(!env.REACT_APP_API_URL) {
      throw Error('Environment setting REACT_APP_API_URL missing')
    }
    
    if(!env.REACT_APP_AUTH_URL) {
      throw Error('Environment setting REACT_APP_AUTH_URL missing')
    }
    
    if(!env.REACT_APP_URL) {
      throw Error('Environment setting REACT_APP_URL missing')
    }

    return {
      apiUrl: env.REACT_APP_API_URL,
      helpUrl: env.REACT_APP_HELP_URL,
      oidcSettings: {
        authority: env.REACT_APP_AUTH_URL,
        client_id: "magicad-customeraccessmanagement-ui",
        scope: "openid profile magicad.useraccessmanagement",
        response_type: "code",
        redirect_uri: `${env.REACT_APP_URL}callback`,
        post_logout_redirect_uri: env.REACT_APP_URL,
        monitorSession: false, // Without this multiple auth callback calls fired
        prompt: 'login'
      }
    }
  }
  